import * as React from 'react';

import WorldHistory1200ToPresent from '../../../containers/WorldHistory1200ToPresent';
import AssignmentFlowNavigation from '../assignment_flow_navigation';
import { getPageTitle, WORLD_HISTORY_1200_TO_PRESENT_SLUG } from '../../../../Shared';


const AssignWorldHistory1200ToPresent = () => {
  document.title = getPageTitle("Assign", "Social Studies | World History 1200 to Present")
  return (
    <div>
      <AssignmentFlowNavigation courseSlug={WORLD_HISTORY_1200_TO_PRESENT_SLUG} />
      <WorldHistory1200ToPresent />
    </div>
  )
}

export default AssignWorldHistory1200ToPresent
